import ServiceIknow, { ConfigKeyType } from '@/modules/globals/features/ServiceIKnow'
import { openNotice } from './Notice'
import getNoticeVisible from './helpers/getNoticeCode'

export default async () => {
    const noticeCode = await getNoticeVisible()

    if (!noticeCode) {
        return Promise.resolve()
    }

    const { getServiceIknow, setServiceIknow } = ServiceIknow({
        configKey: ConfigKeyType.UPDATE_NOTICE,
        requestType: 'security'
    })

    const isClicked = await getServiceIknow()
    if (isClicked) {
        return Promise.resolve()
    }

    setServiceIknow(true)
    return openNotice({
        code: noticeCode
    })
}
